module.exports = __webpack_public_path__ + "static/media/marker_rota_ajuste.04945dc0.png";